import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  getPanelErrorProps,
  TextTitle,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';
import { ValidatedAdStatus } from './ad-status-with-validation';

const getStatusSummary = (i18n, status) => (status === 'Active' ? i18n.getString(_TL_('Ad status: Active')) : i18n.getString(_TL_('Ad status: Paused')));

export const AdStatusSection = React.memo((props) => {
  const {
    status, expand, ...rest
  } = props;
  const i18n = useContext(I18nContext);
  const descriptionsCardSummaryDetails = useMemo(() => getStatusSummary(i18n, status), [status, i18n]);
  const validationProps = useMemo(() => ({
    data: {
      AdStatus: status,
    },
  }), [status]);

  return (
    <ValidatedPanel
      key="status"
      title={<TextTitle
        titleKey={_TL_('Ad status')}
        // icon={TextAssetsImg}
        iconAltText={i18n.getString(_TL_('Ad status'))}
        details={descriptionsCardSummaryDetails}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: 'descriptions',
      }}
      {...rest}
    >
      <ValidatedAdStatus validationProps={validationProps} />
    </ValidatedPanel>
  );
});

AdStatusSection.propTypes = {
  status: PropTypes.string.isRequired,
  onAdStatusChange: PropTypes.func.isRequired,
  expand: PropTypes.func.isRequired,
};
